import round from "../../util/round";
import formatIntWithCommas from "../../util/formatIntWithCommas";
import { AddCostObj } from "../../GlobalTypes";
import { taxableCostsTotal } from "../../util/calcSalesTaxDollar";
import { QuoteObj } from "../../GlobalTypes";

type DealerTaxArgs = {
  status: string;
  dealerTax: number;
  dateOrdered: string | Date;
};

function getDealerTax(taxArgs: DealerTaxArgs) {
  const { status, dealerTax, dateOrdered } = taxArgs;

  if (
    status !== "Quote" &&
    status !== "Archived" &&
    dealerTax &&
    dateOrdered &&
    new Date(dateOrdered) < new Date(2024, 1, 19)
  ) {
    return null;
  }

  return dealerTax || null;
}

type GrandTotalArgs = {
  grandTotal: string;
  salesTax: number;
  adminCharge: number | null;
  hasDealerTax: boolean;
};

function nonMarginGrandTotal(totalArgs: GrandTotalArgs) {
  const { grandTotal, salesTax, adminCharge, hasDealerTax } = totalArgs;

  const grandTotalNoCommas = grandTotal.replaceAll(",", "");
  const total = !adminCharge || adminCharge <= 0
    ? parseFloat(grandTotalNoCommas)
    : hasDealerTax
    ? round(parseFloat(grandTotalNoCommas))
    : round(parseFloat(grandTotalNoCommas) + adminCharge);

  if (salesTax !== 0 && salesTax) {
    const grandWithSalesTax = round(total * (1 + salesTax));
    return formatIntWithCommas(grandWithSalesTax);
  } else {
    return formatIntWithCommas(total);
  }
}

type CustomerArgs = {
  grandTotal: string;
  delivery: number;
  deliveryMarkup: boolean;
  adminCharge: number;
  addCosts: AddCostObj[];
  marginUsed: string;
  markup: boolean;
  salesTax: number;
  hasDealerTax: boolean;
};

function getCustomerTotal(customerArgs: CustomerArgs) {
  const {
    grandTotal,
    delivery,
    deliveryMarkup,
    adminCharge,
    addCosts,
    marginUsed,
    markup,
    salesTax,
    hasDealerTax,
  } = customerArgs;

  var p = grandTotal.replace(/\,/g, "");
  var pInt = parseFloat(p) - delivery;
  var gt = 0;

  console.log(hasDealerTax, adminCharge)

  if (adminCharge && !hasDealerTax) pInt += adminCharge;

  const taxableCosts = addCosts.filter((itm) => itm.taxable);
  const nontaxableCosts = addCosts.filter((itm) => !itm.taxable);

  const validMarginMarkup = marginUsed && Number(marginUsed)

  if (!validMarginMarkup && taxableCosts.length) {
    const costsTotal = taxableCostsTotal(taxableCosts);
    gt = pInt + costsTotal;
  } else if (validMarginMarkup && !taxableCosts.length) {
    gt += !markup
      ? pInt / (1 - parseFloat(marginUsed) / 100)
      : pInt * (parseFloat(marginUsed) / 100 + 1);
  } else if (taxableCosts.length && validMarginMarkup) {
    const costsTotal = taxableCostsTotal(taxableCosts);

    gt += !markup
      ? pInt / (1 - parseFloat(marginUsed) / 100)
      : pInt * (parseFloat(marginUsed) / 100 + 1);
    gt += costsTotal;
  } else {
    gt += pInt;
  }

  if (salesTax !== 0 && salesTax) gt = gt * (1 + salesTax);

  if (deliveryMarkup && validMarginMarkup) {
    gt += !markup
      ? delivery / (1 - parseFloat(marginUsed) / 100)
      : delivery * (parseFloat(marginUsed) / 100 + 1);
  } else {
    gt += delivery;
  }

  if (nontaxableCosts.length) {
    const costsTotal = taxableCostsTotal(nontaxableCosts);
    gt += costsTotal;
  }

  return gt;
}

type AddCostArgs = {
  isLoading: boolean;
  quote: QuoteObj | null;
  dealerTax: boolean;
};

function formatAddCostsObj(addCostArgs: AddCostArgs) {
  const { isLoading, quote, dealerTax } = addCostArgs;

  if (isLoading) return [];
  if (!quote) return [];
  if (quote.additionalCostsPrice && quote.additionalCostsPriceNoTax) {
    return [
      {
        title: quote.additionalCostsTitle || "",
        price: Number(quote.additionalCostsPrice),
        taxable: dealerTax ? false : true,
      },
      {
        title: quote.additionalCostsTitleNoTax || "",
        price: Number(quote.additionalCostsPriceNoTax),
        taxable: false,
      },
    ];
  }

  if (quote.additionalCostsPrice) {
    return [
      {
        title: quote.additionalCostsTitle || "",
        price: Number(quote.additionalCostsPrice),
        taxable: dealerTax ? false : true,
      },
    ];
  }

  if (quote.additionalCostsPriceNoTax) {
    return [
      {
        title: quote.additionalCostsTitleNoTax || "",
        price: Number(quote.additionalCostsPriceNoTax),
        taxable: false,
      },
    ];
  }

  if (quote.addCosts) {
    return quote.addCosts;
  }

  return [];
}

export {
  getDealerTax,
  nonMarginGrandTotal,
  getCustomerTotal,
  formatAddCostsObj,
};
